import { gql } from '@provision/graphql-client';
import { USER_GROUP_FIELDS } from 'src/graphql/entities/user-group';
import { USER_SETTING_VALUE_FRAGMENT } from 'src/graphql/entities/user-setting-value/user-setting-value.fragments';

export const PLATFORM_FIELDS = gql`
  fragment PlatformUserFields on PlatformUser {
    id
    userId
    partnerId
    firstName
    lastName
    email
    createdAt
    updatedAt
    phoneNumber
    isActive
    cognitoUsername
    avatarFileKey
  }
`;

export const PLATFORM_RELATIONS = gql`
  fragment PlatformUserRelations on PlatformUser {
    id
    conversationAssigneeGroups {
      conversationAssigneeGroupId
      id
      name
    }
    userGroups {
      ...UserGroupFields
      ruleValues {
        id
        userGroupRuleId
        value
      }
    }
    userCommunicationPreferences {
      id
      communicationChannel
      priority
    }
    userSettingValues {
      ...UserSettingValueFields
    }
  }
  ${USER_GROUP_FIELDS}
  ${USER_SETTING_VALUE_FRAGMENT}
`;
